import React, { PropsWithoutRef, useEffect, useState } from "react";
import {
  AppBar,
  Toolbar,
  IconButton,
  Box,
  Menu,
  MenuItem,
  Typography,
  Button,
} from "@mui/material";
import LockIcon from '@mui/icons-material/Lock';
import PersonIcon from "@mui/icons-material/Person";
import LogoutIcon from "@mui/icons-material/Logout";
import { useNavigate } from "react-router-dom";
import { SIDEBAR_WIDTH } from "../constants";
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import MenuIcon from "@mui/icons-material/Menu";
import { removeFromStorage, showError, showToast } from "../helpers";
import secureLocalStorage from "react-secure-storage";
import { STORAGE_KEYS } from "../constants/storagekeys";
import { setCredentials } from "../reducers/authSlice";
import LogoutModal from "../Modals/LogoutModal";
import { useLazyLogoutQuery } from "../services/auth";
import { useAppDispatch } from "../hooks/store";
import useAuth from "../hooks/useAuth";

interface Props {
  handleSidebarToggle: () => void;


}

function Topbar({ handleSidebarToggle }: PropsWithoutRef<Props>) {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const user = useAuth();

  useEffect(() => {
    if (window) {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, []);

  const [scroll, setScroll] = useState(false);
  const [logoutMutation] = useLazyLogoutQuery();
  const [openLogout, setOpenLogout] = useState<boolean>(false);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const [anchorEl1, setAnchorEl1] = React.useState<null | HTMLElement>(null);
  const open1 = Boolean(anchorEl1);
  const handleClick1 = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl1(event.currentTarget);
  };
  const handleClose1 = () => {
    setAnchorEl1(null);
  };


  useEffect(() => {
    window.addEventListener("scroll", () => {
      setScroll(window.scrollY > 10);
    });
  }, []);


  const handleLogout = async () => {
    try {
      const res = await logoutMutation({}).unwrap();
      if (res.statusCode == 200) {
        if (true) {
          showToast('Logout Successful');
          secureLocalStorage.removeItem('permissions');
          secureLocalStorage.removeItem('role');
          removeFromStorage(STORAGE_KEYS.token);
          removeFromStorage(STORAGE_KEYS.tempToken);
          dispatch(
            setCredentials({
              user: null,
              token: null,
            }),
          );
          navigate('/');
        }
      }
    } catch (error: any) {
      console.log('error :', error);
      showError(error?.data?.message);
    }
  };



  return (
    <Box className="site_header">
      <AppBar
        position="fixed"
        className="topbar"
        sx={{
          width: { lg: `calc(100% - ${SIDEBAR_WIDTH}px)` },
          ml: { lg: `${SIDEBAR_WIDTH}px` },
        }}
      >
        <Toolbar sx={{ display: "flex", justifyContent: "space-between" }}>
          <div className="topbar_left">
            <IconButton
              onClick={handleSidebarToggle}
            >
              <MenuIcon />
            </IconButton>
          </div>
          <div className="topbar_right">
            {/* <Box>
              <IconButton
                className="icon_btn"
                aria-controls={open1 ? "basic-menu1" : undefined}
                aria-haspopup="true"
                aria-expanded={open1 ? "true" : undefined}
                onClick={handleClick1}
              >
                <NotificationsActiveIcon />
              </IconButton>
              <Menu
                className="notiDropdown_menu"
                id="basic-menu1"
                anchorEl={anchorEl1}
                open={open1}
                onClose={handleClose1}
                MenuListProps={{
                  "aria-labelledby": "basic-button1",
                }}
                transformOrigin={{ horizontal: "right", vertical: "top" }}
                anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
              >
                <Box className="noti_head">
                  <Typography component="h2">Notifications</Typography>
                  <Button
                    className="btn btn_primary sm"
                    onClick={() => { navigate("/recieved-notifications"); handleClose1() }}
                  >
                    See All
                  </Button>
                </Box>
                <ul className="noti_list">
                  <li>
                    <figure>
                       <img alt="user" src={user?.image || '/static/images/user_placeholder.png'} />
                    </figure>
                    <div className="noti_info">
                      <Typography component="h3">
                        Emma Smith
                        <Typography component="span">1 Day ago</Typography>
                      </Typography>
                      <Typography component="p">
                        Lorem ipsum dolor sit amet consectetur, adipisicing elit
                        dolor sit amet consectetur.
                      </Typography>
                    </div>
                  </li>
                  <li>
                       <figure>
                       <img alt="user" src={user?.image || '/static/images/user_placeholder.png'} />
                    </figure>
                    <div className="noti_info">
                      <Typography component="h3">
                        Emma Smith
                        <Typography component="span">1 Day ago</Typography>
                      </Typography>
                      <Typography component="p">
                        Lorem ipsum dolor sit amet consectetur, adipisicing elit
                        dolor sit amet consectetur.
                      </Typography>
                    </div>
                  </li>
                  <li>
                    <figure>
                      <img alt="user" src={user?.image || '/static/images/user_placeholder.png'} />

                    </figure>
                    <div className="noti_info">
                      <Typography component="h3">
                        Emma Smith
                        <Typography component="span">1 Day ago</Typography>
                      </Typography>
                      <Typography component="p">
                        Lorem ipsum dolor sit amet consectetur, adipisicing elit
                        dolor sit amet consectetur.
                      </Typography>
                    </div>
                  </li>
                </ul>
              </Menu>
            </Box> */}

            <Box>
              <IconButton
                className="topbar_user_btn"
                aria-controls={open ? "basic-menu" : undefined}
                aria-haspopup="true"
                aria-expanded={open ? "true" : undefined}
                onClick={handleClick}
              >
                <img alt="user" src={user?.image || '/static/images/user_placeholder.png'} />
                <Typography component="span" sx={{ ml: 1 }}>
                  {user?.fullName || user?.name || 'Admin'}
                </Typography>
              </IconButton>
              <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                  "aria-labelledby": "basic-button",
                }}
                transformOrigin={{ horizontal: "right", vertical: "top" }}
                anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
              >
                <MenuItem onClick={() => { navigate("/manage-profile"); handleClose() }}>
                  <PersonIcon /> My Profile
                </MenuItem>
                <MenuItem onClick={() => { navigate("/manage-profile/change-password"); handleClose() }}>
                  <LockIcon /> Change Password
                </MenuItem>
                <MenuItem onClick={() => setOpenLogout(true)}>
                  <LogoutIcon /> Logout
                </MenuItem>
              </Menu>
            </Box>
          </div>
        </Toolbar>
      </AppBar>
      <LogoutModal
        openLogout={openLogout}
        setOpenLogout={setOpenLogout}
        handleLogout={handleLogout}
      />
    </Box>
  );
}

export default Topbar;
function logoutMutation(arg0: {}) {
  throw new Error("Function not implemented.");
}

function dispatch(arg0: any) {
  throw new Error("Function not implemented.");
}

